import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faYoutube,faFontAwesomeFlag} from '@fortawesome/free-brands-svg-icons'
import { faGlobe, faMapMarkerAlt, faFutbol,faVenus } from '@fortawesome/free-solid-svg-icons'
import Header2 from '../Header/Header2';
import male from "../Photo/male.png"
import female from "../Photo/female.png"

const TeamDetail = () => {
    const {id}=useParams()
    const [teams,setTeams]=useState({})
    useEffect(()=>{
        const url =`https://www.thesportsdb.com/api/v1/json/1/lookupleague.php?id=${id}`
        fetch(url)
        .then(res=>res.json())
        .then(data=>setTeams(data.leagues[0]))
    },[id])
    const { intFormedYear, strCountry, strSport, strGender,strTwitter, strWebsite, strYoutube, strBadge, strDescriptionEN, strDescriptionFR, strLeague}=teams
    let logo;
    if (strGender==="Male"){
        logo=male

    }
   
    else{
        logo=female
    }
    return (
        <div >
            <Header2 img={strBadge}></Header2>

            <div style={{ backgroundColor: "lightgreen",borderRadius:"10px" }} className="p-1 my-3 mx-5">
                <div className="row m-4">
                    <div style={{ border: "none" }} className="col-sm-6 p-1 m-1">
                        <div style={{ border: "none",borderRadius:"10px" }} className="card">
                            <div style={{ border: "none" }} className="card-body">
                                <h3 className="card-title">{strLeague}</h3>
                                <h6 className="card-text"><FontAwesomeIcon icon={faMapMarkerAlt} className="mx-2"></FontAwesomeIcon>Founded: {intFormedYear}</h6>
                                <h6><FontAwesomeIcon icon={faFontAwesomeFlag} className="mx-2"></FontAwesomeIcon>Country: {strCountry}</h6>
                                <h6><FontAwesomeIcon icon={faFutbol} className="mx-2"></FontAwesomeIcon>Sport Type: {strSport}</h6>
                                <h6><FontAwesomeIcon icon={faVenus} className="mx-2"></FontAwesomeIcon>Gender: {strGender}</h6>
                                
                            </div>
                        </div>
                    </div>
                    <div style={{border:"none"}} className="col-sm-5 p-1 m-1">
                        <div style={{ borderRadius: "10px"}} className="card">
                            <img style={{ height: "200px", float: "right" }} src={logo} alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ border: "none",backgroundColor:"lightgray",borderRadius:"10px" }} className="card m-5 p-3 ">
                    <div className="card-body">
                    <p>{strDescriptionEN}</p>
                     <br></br>
                     <p>{strDescriptionFR}</p>
                    </div>

                 </div>

            <div style={{border:"none",backgroundColor:"lightblue",borderRadius:"10px"}} className="card m-5 p-1">
                <div className="card-body">
                    <div style={{textAlign:"center"}}>
                
                        <a href={`https://${strTwitter}`} target="blank"><FontAwesomeIcon icon={faTwitter} className="mx-2" size="2x"></FontAwesomeIcon></a>

                        <a href={`https://${strWebsite}`} target="blank"><FontAwesomeIcon icon={faGlobe} className="mx-2" size="2x"></FontAwesomeIcon></a>

                        <a href={`https://${strYoutube}`} target="blank"><FontAwesomeIcon icon={faYoutube} className="mx-2" size="2x"></FontAwesomeIcon></a>
                    </div>
                </div>

            </div>
  

            <div>
                
            </div>
        </div>
    );
};

export default TeamDetail;